// extracted by mini-css-extract-plugin
export default {"container":"UserPage_container__qulzD","documents":"UserPage_documents__1rPUM","update-profile":"UserPage_update-profile__E2NRP","logout":"UserPage_logout__Mnpyp"};